module.exports = __webpack_public_path__ + "img/contents.07eb5ea6.svg";